var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBancaSistemaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.5,
    height: 40.061,
    viewBox: "0 0 98.5 40.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Banca_Sistema_logo",
    transform: "translate(0.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M82.548,0h4.7c3.587,0,5.645,1.215,5.645,3.648a3.3,3.3,0,0,1-2.157,2.941c1.842.942,2.569,1.726,2.569,3.49,0,2.8-2.326,4.079-5.863,4.079h-4.9Zm3.344,5.607h1.164c1.5,0,2.5-.706,2.5-1.667,0-1.039-.752-1.705-2.326-1.705H85.892Zm0,6.313H87.3c1.745,0,2.666-.824,2.666-2.058,0-1.352-1.164-2.02-2.907-2.02H85.892Z",
    transform: "translate(-66.884)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M153.78,3.059h.049l1.623,5.725h-3.319l1.648-5.725ZM151.7,0l-4.337,14.157h3.222l.944-2.981h4.629L157,14.157h3.2L155.985,0Z",
    transform: "translate(-119.387)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2",
    d: "M236.551,8.5,231.9.11H228.24V14.267h3.053V5.129h.049l5.112,9.139h3.2V.11H236.6V8.5Z",
    transform: "translate(-184.914 -0.089)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M303.482,9.985c0,1.527.849,1.946,2.182,1.946s2.182-.42,2.182-1.946V9.07h3.344v.572c0,3.4-2.279,4.618-5.525,4.618s-5.526-1.221-5.526-4.618V4.718c0-3.4,2.279-4.618,5.526-4.618s5.525,1.221,5.525,4.618v.038h-3.344V4.374c0-1.527-.849-1.946-2.182-1.946s-2.182.42-2.182,1.946Z",
    transform: "translate(-243.158 -0.081)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M372.228,3.169h.049L373.9,8.894h-3.319l1.648-5.725ZM370.145.11l-4.337,14.157h3.222l.944-2.981H374.6l.847,2.981h3.2L374.435.11Z",
    transform: "translate(-296.358 -0.089)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4",
    width: 59.603,
    height: 3.558,
    transform: "translate(22.736 17.735)",
    fill: "#b91f27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M8.692,135.966A2.671,2.671,0,0,0,6.068,134c-1.248,0-1.975.608-1.975,1.6,0,2.208,8,2.37,8,6.952,0,2.514-2.208,4.175-5.976,4.175-2.909,0-5.17-1.236-6.131-4.115l3.534-.587A2.841,2.841,0,0,0,6.3,144.42c1.246,0,2.208-.647,2.208-1.743,0-2.755-8-2.8-8-6.893,0-2.512,1.922-4.094,5.636-4.094,3.2,0,5.144,1.481,5.767,3.547l-3.22.731Z",
    transform: "translate(0 -106.685)",
    fill: "#000413"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5",
    width: 3.585,
    height: 15.082,
    transform: "translate(15.632 24.979)",
    fill: "#000413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M128.642,135.966A2.671,2.671,0,0,0,126.018,134c-1.248,0-1.975.608-1.975,1.6,0,2.208,8,2.37,8,6.952,0,2.514-2.208,4.175-5.976,4.175-2.909,0-5.17-1.236-6.131-4.115l3.534-.587a2.841,2.841,0,0,0,2.78,2.392c1.246,0,2.208-.647,2.208-1.743,0-2.755-8-2.8-8-6.893,0-2.512,1.922-4.094,5.636-4.094,3.2,0,5.144,1.481,5.767,3.547l-3.22.731Z",
    transform: "translate(-97.174 -106.685)",
    fill: "#000413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon6",
    d: "M198.383,134.1v12.534h3.585V134.1h4.183V131.55H194.2V134.1Z",
    transform: "translate(-157.337 -106.571)",
    fill: "#000413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon7",
    d: "M282.959,146.632v-2.548h-6.494v-3.968h4.755v-2.548h-4.755V134.1H282.7V131.55H272.88v15.082Z",
    transform: "translate(-221.077 -106.571)",
    fill: "#000413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon8",
    d: "M354.492,141.45l-3.249-9.9H346.23v15.082h3.065V134.767h.051l3.82,11.866h2.7l3.82-11.866h.051v11.866H362.8V131.55H357.79l-3.247,9.9Z",
    transform: "translate(-280.5 -106.571)",
    fill: "#000413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M453.111,134.808h.053l1.739,6.1h-3.56Zm-2.233-3.258-4.65,15.082h3.456l1.012-3.175h4.962l.909,3.175H460l-4.521-15.082h-4.6Z",
    transform: "translate(-361.508 -106.571)",
    fill: "#000413"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8",
    width: 3.558,
    height: 3.558,
    transform: "translate(15.665 17.735)",
    fill: "#b91f27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancaSistemaLogo);
export default __webpack_public_path__ + "static/media/banca-sistema-logo.567de2b060c4aa22293c99b757ec7505.svg";
export { ForwardRef as ReactComponent };